export default "__VITE_ASSET__43356b47__"